import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export const sessionsBeforeEnter = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const { useAuthorizedSessionsStore } = await import('@/entities/authorized-session')
  const { fetch } = useAuthorizedSessionsStore()
  await fetch()
  next()
}
